// extracted by mini-css-extract-plugin
export const gridStyles = "grid-module--gridStyles--1sIoq";